<!--  -->
<template>
  <div :class="['myShopCar', { inApp: $root.$data.isApp || this.$root.$data.miniprogram }]">
    <common-title titleName="购物车" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <template v-if="loadingTip">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="contentCenter">
          <div v-for="(item, index) in list" :key="index">
            <!-- 课程 -->
            <SingleCourse
              v-if="item.type === 1"
              :courseInfo="item"
              @chooseType="chooseSingleType"
              @click.native="enterDetails(item)"
              @deleteGood="deleteGoodItem"
              @checkOneCourse="checkOneCourse"
              @cleanCourse="cleanCourse"
              :checkList="checkList"
              :disabled="hasSelectedPackage"
            />
            <!-- 套餐 -->
            <PackageCourse
              v-if="item.type === 2"
              :courseInfo="item"
              @chooseType="choosePackageType"
              @click.native="packageDetails(item)"
              @deleteGood="deleteGoodItem"
              @checkOneCourse="checkOneCourse"
              @cleanCourse="cleanCourse"
              :checkList="checkList"
              :disabled="hasSelectedSingle"
            />
          </div>
          <template v-if="failureList.length">
            <div class="failureGoods">
              <div class="failureGoodsTop">
                <div class="goodsNum" @click="foldFailureGoods">
                  {{ failureList.length }}件失效商品<img :src="brandFold ? zk : sq" alt="" />
                </div>
                <div class="clearGoods" @click="getCleanAllGoods">清空失效商品</div>
              </div>
              <template v-if="!brandFold">
                <div v-for="(item, index) in failureList" :key="index">
                  <!-- 课程 -->
                  <SingleCourse
                    v-if="item.type === 1"
                    :courseInfo="item"
                    :doNot="true"
                    @deleteGood="deleteGoodItem"
                    @click.native="enterDetails(item)"
                  />
                  <!-- 套餐 -->
                  <PackageCourse
                    v-if="item.type === 2"
                    :courseInfo="item"
                    :doNot="true"
                    @deleteGood="deleteGoodItem"
                    @click.native="packageDetails(item)"
                  />
                </div>
              </template>
            </div>
          </template>
        </div>
        <!-- 缺省页 -->
        <NoData v-if="!list.length && !failureList.length" />
      </van-pull-refresh>
      <!-- 底部 -->
      <div class="footBox" v-if="list.length">
        <div class="footCenter">
          <div class="checkAllBtn" @click="checkAll">
            <img :src="selectAll ? checked : noCheck" alt="" />全选
          </div>
          <div class="footRight">
            <div class="marketPrice">
              <div class="total">优惠后合计：</div>
              <div class="totalPrice"><span>¥</span>{{ totalPrice }}</div>
            </div>
            <div :class="['settlement', { setGray: !checkList.length }]" @click="settlement">
              结算（{{ totalNum }}）
            </div>
          </div>
        </div>
      </div>
      <!-- 普通课程修改规格 -->
      <SingleSelect
        v-if="showSelect === 1"
        @singleClose="singleClose"
        :currentCourse="currentCourse"
        @reviseType="reviseType"
      />
      <!-- 套餐修改规格 -->
      <PackageSelect
        v-if="showSelect === 2"
        @singleClose="singleClose"
        :currentCourse="currentCourse"
        @reviseType="reviseType"
      />
    </template>
    <div v-else class="loadingCenter">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CommonTitle from '@/components/header/CommonTitle.vue';
import {
  reqCartList,
  reqCleanAll,
  reqDeleteGood,
} from '@/api/courseDetail/shoppingCar/shoppingCar';
import { reqPrice, reqOrderProductCheck } from '@/api/pay/index';
import { setTokenFromCookie, gioPlatform, beforePageName } from '@/utils/tools';
import SingleCourse from './components/singleCourse.vue';
import PackageCourse from './components/packageCourse.vue';
import NoData from './components/noData.vue';
import SingleSelect from './components/singleSelect.vue';
import PackageSelect from './components/packageSelect.vue';

export default {
  data() {
    return {
      checked: require('@/assets/img/car/cked.png'),
      noCheck: require('@/assets/img/car/nck.png'),
      zk: require('@/assets/img/car/zk.png'),
      sq: require('@/assets/img/car/sq.png'),
      selectAll: false, // 全选
      brandFold: true, // 展开收起 默认收起状态
      showSelect: 0, //  1普通产品选择规格,2套餐选择规格
      packageShow: false, // 套餐选择规格
      list: [], // 有效商品列表
      failureList: [], // 失效商品列表
      totalNum: 0, // 结算数量
      totalPrice: '0.00', // 总价
      checkList: [], // 已勾选的课程列表
      currentCourse: null, // 当前课程信息(修改规格时使用)
      loadingTip: false,
      isLoading: false, // 下拉刷新
      gioList: [], // 埋点所需数据
      hasSelectedPackage: false, // 是否有选中的套餐
      hasSelectedSingle: false, // 是否有选中的单品
    };
  },

  components: {
    CommonTitle,
    SingleCourse,
    PackageCourse,
    NoData,
    SingleSelect,
    PackageSelect,
  },

  computed: {
    ...mapState(['userInfo', 'allAcvitity']),
  },
  watch: {},
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },

  created() {
    this.getCartList();
  },

  methods: {
    // 选中的课程List
    checkOneCourse(data) {
      this.checkList.push(data);
      // 更新选中类型状态
      if (data.type === 2) {
        this.hasSelectedPackage = true;
      } else {
        this.hasSelectedSingle = true;
      }
      if (this.checkList.length === this.list.length) {
        this.selectAll = true;
      }
      this.getPrice();
    },
    // 取消选中的课程
    cleanCourse(data) {
      this.checkList = this.checkList.filter((item) => item.cartId !== data.cartId);

      // 更新选中类型状态（判断剩余选中项中是否还有套餐/单品）
      this.hasSelectedPackage = this.checkList.some((item) => item.type === 2);
      this.hasSelectedSingle = this.checkList.some((item) => item.type === 1);

      if (!this.checkList.length) {
        this.totalPrice = '0.00';
      }
      if (this.checkList.length !== this.list.length) {
        this.selectAll = false;
      }

      this.getPrice();
    },
    // 全选
    checkAll() {
      // // 选择
      if (!this.selectAll) {
        // 全选时先判断是否包含两种类型
        const hasSingle = this.list.some((item) => item.type === 1);
        const hasPackage = this.list.some((item) => item.type === 2);
        if (hasSingle && hasPackage) {
          this.$toast('套餐和单品不可同时选择');
          return;
        }
        // 全选时更新选中类型状态
        this.checkList = JSON.parse(JSON.stringify(this.list));
        this.hasSelectedPackage = this.list.some((item) => item.type === 2);
        this.hasSelectedSingle = this.list.some((item) => item.type === 1);

        this.checkList = JSON.parse(JSON.stringify(this.list));
        this.getPrice();
      }
      // // 取消
      if (this.selectAll) {
        this.totalNum = 0;
        this.totalPrice = '0.00';
        this.checkList = [];
        this.hasSelectedPackage = false;
        this.hasSelectedSingle = false;
      }

      this.selectAll = !this.selectAll;
    },
    getSonList(data) {
      const sonPackageList = [];
      data.map((val) => {
        sonPackageList.push({
          productId: val.productId,
          skuId: val.productSkuId,
          packageGroupId: val.packageGroupId || '',
        });
      });
      return sonPackageList;
    },
    // 计算价格
    async getPrice() {
      if (!this.checkList.length) {
        this.totalNum = 0;
        this.totalPrice = '0.00';
        return;
      }
      // 普通产品
      const coureSingleList = [];
      const courePackageList = [];
      // 已选中的课程
      this.checkList.map((item) => {
        if (item.type === 1) {
          coureSingleList.push({
            productId: item.cartProductItem.productId,
            skuId: item.cartProductItem.productSkuId,
          });
        }
        if (item.type === 2) {
          courePackageList.push({
            packageId: item.cartPackageItem.packageId,
            packageProductSkuReqList: this.getSonList(item.cartPackageItem.cartProductItemList),
          });
        }
      });
      this.totalNum = this.checkList.length;
      const res = await reqPrice({
        promotionBasicPrice: {
          endPoint: this.$root.$data.isApp ? 2 : 3,
          platform: 1,
        },
        promotionProductSkuPriceList: coureSingleList,
        promotionProductPackageReqList: courePackageList,
      });
      if (res.code === 0) {
        this.totalPrice = res?.data.orderPayPrice.toFixed(2);
        this.gioList = res?.data;
      }
    },
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
      setTimeout(() => {
        this.checkOrder();
      }, 500);
    },

    // 结算
    settlement() {
      // 校验登陆
      if (!this.userInfo.id) {
        const { isApp = false } = this.$root.$data;
        if (isApp) {
          this.$sendToApp('login', {}, true).then(async () => {
            setTokenFromCookie();
            await this.$root.getUserInfo();
          });
        } else {
          const param = { redirect: '/shoppingCar' };
          this.$router.push({ path: '/registrationLogin', query: param });
        }
      } else {
        this.checkOrder();
      }
    },
    async checkOrder() {
      //  没有产品时
      if (!this.checkList.length) return;
      // 套餐与产品不可同时下单
      if (
        this.checkList.find((item) => item.type === 1) &&
        this.checkList.find((item) => item.type === 2)
      ) {
        this.$toast('套餐与产品不可同时下单，请分开购买哦');
        return;
      }
      // 全部为普通产品
      const someResult = this.checkList.some((item) => item.type === 1);
      let checkResult = '';
      if (someResult) {
        checkResult = await reqOrderProductCheck({
          products: this.checkList.map((productInfo) => ({
            cartId: productInfo.cartId,
            productId: productInfo.cartProductItem.productId,
            productSkuId: productInfo.cartProductItem.productSkuId,
            quantity: 1,
            type: 1,
            promotion: '',
            userId: this.$store.state.userInfo.id,
          })),
          userId: this.$store.state.userInfo.id,
        });
      } else {
        // 购物车多套餐购买
        const products = [];
        this.checkList.map((item) => {
          item.cartPackageItem.cartProductItemList.map((productInfo) => {
            products.push({
              cartId: item.cartId,
              productId: productInfo.productId,
              productSkuId: productInfo.productSkuId,
              packageId: item.cartPackageItem.packageId,
              packageGroupId: productInfo.packageGroupId,
              quantity: 1,
              type: 1,
              promotion: '',
              userId: this.$store.state.userInfo.id,
            });
          });
        });
        checkResult = await reqOrderProductCheck({
          products,
          userId: this.$store.state.userInfo.id,
        });
      }
      if (checkResult.code === 0) {
        if (!checkResult?.data.repeatPurchaseProductId) {
          if (someResult) {
            const query = [];
            this.checkList.map((item) => {
              query.push({
                productId: item.cartProductItem.productId,
                skuId: item.cartProductItem.productSkuId,
                cartId: item.cartId,
              });
            });
            console.log(query, 'query');
            if (!this.$root.$data.isApp) {
              this.$router.push({
                path: '/payOrder',
                query: { product: JSON.stringify(query) },
              });
            } else {
              // app内
              // eslint-disable-next-line no-lonely-if
              this.$sendToApp('buyCourseNew', { product: JSON.stringify(query) }, false);
            }
          } else {
            const query = [];
            this.checkList.map((item) => {
              query.push({
                packageId: item.cartPackageItem.packageId,
                cartId: item.cartId,
                packageProductSkuReqList: this.getSonList(item.cartPackageItem.cartProductItemList),
              });
            });

            this.$router.push({
              path: '/payOrder',
              query: {
                product: JSON.stringify(query),
                cart: 'cart',
              },
            });
          }
          this.gioDefault();
        } else {
          this.$toast(
            `课程【${checkResult?.data?.repeatPurchaseProductName.join()}】不可重复购买，请重新选择产品后再下单`,
          );
        }
      } else {
        this.$toast(checkResult.msg);
      }
    },

    // 失效商品折叠
    foldFailureGoods() {
      this.brandFold = !this.brandFold;
    },
    // 选择规格普通课程弹窗
    chooseSingleType(data) {
      this.currentCourse = data;
      this.showSelect = 1;
    },
    // 套餐选择规格
    choosePackageType(data) {
      this.currentCourse = data;
      this.showSelect = 2;
    },
    singleClose() {
      this.showSelect = 0;
    },
    // 修改规格成功
    async reviseType(data) {
      this.$toast.loading({
        message: '修改中...',
        forbidClick: true,
        duration: 0,
      });
      // 修改规格成功更新checkList 数据
      await this.getCartList();
      if (this.checkList.length) {
        this.checkList.map((item, index) => {
          this.list.map((val) => {
            if (item.cartId === val.cartId && item.cartId === data.cartId) {
              this.$set(this.checkList, index, val);
            }
          });
        });
        // 修改规格后更新价格
        this.getPrice();
      }
      this.$toast.clear();
      this.$toast('修改成功');
    },
    // 获取购物车列表
    async getCartList() {
      const res = await reqCartList();
      if (res.code === 0) {
        // loading结束
        this.loadingTip = true;
        if (!res?.data) {
          this.list = [];
          this.failureList = [];
          return;
        }
        this.list = res?.data.cartItemList;
        this.list.map((item) => {
          Object.assign(item, {
            isSelect: false,
          });
        });

        this.failureList = res?.data.cartInvalidItemList;
      }
    },
    // 删除购物车中某个商品
    async deleteGoodItem(cartId) {
      const res = await reqDeleteGood(cartId);
      if (res.code === 0 && res?.data) {
        // console.log(this.checkList, 'deleteGood');
        this.list.map((item, index) => {
          if (item.cartId === cartId) {
            this.list.splice(index, 1);
          }
        });

        // eslint-disable-next-line no-unused-expressions
        this.checkList?.map((item, index) => {
          if (item.cartId === cartId) {
            this.checkList.splice(index, 1);
          }
        });

        // eslint-disable-next-line no-unused-expressions
        this.failureList?.map((item, index) => {
          if (item.cartId === cartId) {
            this.failureList.splice(index, 1);
          }
        });
        this.getPrice();
        this.$toast('删除成功');
      }
    },

    // 清除购物车中所有失效商品
    async getCleanAllGoods() {
      const res = await reqCleanAll();
      if (res.code === 0) {
        this.failureList = [];
        this.$toast('失效商品已清空');
      }
    },
    // 跳普通产品课程详情
    enterDetails(data) {
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail', Number(data.cartProductItem.productId), false);
        return;
      }
      sessionStorage.setItem('back', true);
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: data.cartProductItem.productId,
        },
      });
    },
    // 套餐课程详情
    packageDetails(data) {
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp('goToCombinationCourse', Number(data.cartPackageItem.packageId), false);
        return;
      }
      sessionStorage.setItem('back', true);
      this.$router.push({
        path: '/combinationCourse',
        query: {
          combinationId: data.cartPackageItem.packageId,
        },
      });
    },
    async onRefresh() {
      await this.getCartList();
      this.checkList = [];
      this.totalNum = 0;
      this.totalPrice = '0.00';
      this.selectAll = false;
      // this.$toast('刷新成功');
      this.isLoading = false;
    },
    // gio埋点 结算
    async gioDefault() {
      const beforePage = this.$route.query.beforePageName;
      const courseIdList = [];
      const courseNameList = [];
      const allianceId = [];
      const allianceName = [];
      const fullReductionId = [];
      const fullReductionName = [];
      const secondsKillNameList = [];
      const {
        orderPayPrice,
        orderTotalPrice,
        productCalculateResultRespList,
        fullDiscountPrice,
        unionDiscountPrice,
        unionCalculateResultRespList,
        promotionFullCalculateResultRespList,
        singleCalculateResultRespList,
        productPackageCalculateResultRespList,
      } = this.gioList;
      if (productCalculateResultRespList) {
        // eslint-disable-next-line no-unused-expressions
        productCalculateResultRespList?.forEach((element) => {
          courseIdList.push(element.productId);
          courseNameList.push(element.productName);
        });
      } else {
        // 注：套餐与普通字段不同取productPackageCalculateResultRespList
        productPackageCalculateResultRespList.forEach((item) => {
          item.packageDetailCalculateResultRespList.forEach((element) => {
            courseIdList.push(element.productId);
            courseNameList.push(element.productName);
          });
        });
      }

      if (unionDiscountPrice) {
        unionCalculateResultRespList.forEach((element) => {
          allianceId.push(element.promotionId);
          allianceName.push(element.promotionName);
        });
      }
      if (fullDiscountPrice) {
        promotionFullCalculateResultRespList.forEach((element) => {
          fullReductionId.push(element.promotionId);
          fullReductionName.push(element.promotionName);
        });
      }
      if (singleCalculateResultRespList) {
        singleCalculateResultRespList.forEach((element) => {
          if (element.promotionLabel === 2 || element.promotionLabel === 3) {
            secondsKillNameList.push(element.promotionName);
          }
        });
      }

      // 立即购买埋点
      // eslint-disable-next-line
      gio('track', 'buyCourse_event', {
        courseIdList_var: courseIdList.toString(), // 课程 ID 列表
        courseNameList_var: courseNameList.toString(), // 课程名称列表
        courseTotalPrice_var: secondsKillNameList.length > 0 ? orderPayPrice : orderTotalPrice, // 课程总价
        isAlliance_var: unionDiscountPrice ? '是' : '否', // 是否参加联报
        allianceId_var: unionDiscountPrice ? allianceId?.toString() : null, // 联报活动ID
        allianceName_var: unionDiscountPrice ? allianceName?.toString() : null, // 联报活动名称
        allianceDiscountAmount_var: unionDiscountPrice || null, // 联报优惠金额
        isSecondsKill_var: secondsKillNameList.length > 0 ? '是' : '否', // 是否参加秒杀
        secondsKillNameList_var:
          secondsKillNameList.length > 0 ? secondsKillNameList?.toString() : null, // 秒杀活动名称列表
        isFullReduction_var: fullDiscountPrice ? '是' : '否', // 是否参加满减
        fullReductionId_var: fullDiscountPrice ? fullReductionId?.toString() : null, // 满减活动ID
        fullReductionName_var: fullDiscountPrice ? fullReductionName?.toString() : null, // 满减活动名称
        fullReductionAmount_var: fullDiscountPrice || null, // 满减优惠金额
        platform_var: gioPlatform(),
        beforePageName_var: beforePageName(beforePage),
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.myShopCar {
  width: 100%;
  height: 100%;
  padding-top: 130px;
  padding-bottom: 130px;
  background: #f9f9f9;

  &.inApp {
    padding-top: 50px;
    padding-bottom: 30px;
  }
  .contentCenter {
    box-sizing: border-box;
    width: 100%;
    padding-right: 40px;
    padding-bottom: 162px;
    .failureGoods {
      width: 100%;
      margin-top: 30px;
      .failureGoodsTop {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 36px;
        .goodsNum {
          display: inline-block;
          box-sizing: border-box;
          margin-left: 255px;
          padding: 4px 8px 4px 24px;
          color: #999;
          font-weight: 400;
          font-size: 28px;
          line-height: 48px;
          background: #fff;
          border-radius: 8px;
          img {
            width: 32px;
            height: 32px;
            margin-right: 4px;
            vertical-align: -5px;
          }
        }
        .clearGoods {
          color: #999;
          font-weight: 400;
          font-size: 24px;
        }
      }
    }
  }
  .footBox {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    .footCenter {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      width: 100%;
      padding: 10px 40px 68px 40px;
      background: #fff;
      .checkAllBtn {
        display: flex;
        color: #999;
        font-weight: 400;
        font-size: 32px;
        line-height: 48px;
        img {
          display: block;
          width: 48px;
          height: 48px;
          margin-right: 4px;
        }
      }
      .footRight {
        display: flex;
        .marketPrice {
          margin-right: 20px;
          .total {
            color: #333;
            font-weight: 400;
            font-size: 24px;
            line-height: 34px;
          }
          .totalPrice {
            color: #ff3938;
            font-weight: normal;
            font-size: 40px;
            line-height: 46px;
            span {
              font-size: 24px;
            }
          }
        }
        .settlement {
          width: 260px;
          height: 78px;
          color: #fff;
          font-weight: 500;
          font-size: 32px;
          line-height: 78px;
          text-align: center;
          background: linear-gradient(270deg, #ff6c02 0%, #ff7f41 100%);
          border-radius: 39px;
        }
        .setGray {
          background: #999;
        }
      }
    }
  }
}
.loadingCenter {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80vh;
}
</style>
